import { Camera, Search, CalendarCheck, CheckCircle2 } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const icons = [Camera, Search, CalendarCheck, CheckCircle2];

const HowItWorks = () => {
  const { t, isRTL } = useLanguage();
  return (
    <section id="how" className="relative py-20 md:py-28" data-testid="how-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 bg-white/5 text-[11px] tracking-[0.25em] uppercase font-display text-white/70">
            <span className="w-1.5 h-1.5 rounded-full bg-[#e10600]" />
            {t.how.eyebrow}
          </div>
          <h2 className="mt-4 font-display font-black text-3xl md:text-5xl tracking-tight">
            {t.how.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {t.how.steps.map((s, i) => {
            const Icon = icons[i];
            return (
              <div
                key={s.t}
                className="relative rounded-2xl border border-white/10 bg-[#111] p-6 md:p-7 overflow-hidden"
                data-testid={`how-step-${i}`}
              >
                <div
                  className="absolute top-4 font-display font-black text-[84px] leading-none text-white/[0.05] select-none"
                  style={isRTL ? { left: 16 } : { right: 16 }}
                >
                  0{i + 1}
                </div>
                <div className="relative">
                  <div className="w-11 h-11 rounded-xl bg-[#e10600]/12 border border-[#e10600]/30 flex items-center justify-center mb-5">
                    <Icon className="w-5 h-5 text-[#e10600]" />
                  </div>
                  <h3 className="font-display font-bold text-lg text-white">{s.t}</h3>
                  <p className="mt-2 text-white/60 text-sm leading-relaxed">{s.d}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
